(function ($) {
	// Menu
	function menuToggle(e) {
		$('.mobile-menu-button').toggleClass('open');
		$('.main-navbar').toggleClass('open');
		$('body').toggleClass('no-scroll');
	}
	$('.mobile-menu-button').on('click', menuToggle);

	function submenuToggle(e) {

		const isMobile = window.innerWidth < 1200

		if (!isMobile) {
			return;
		}

		e.preventDefault()

		if ($($(this).attr('href')).length) {
			menuToggle();
			closeMenuOnClick();
			return;
		}

		$(this).parent().toggleClass('active');
		let submenu = $(this).next('ul');

		if ($(this).parent().hasClass('active') && submenu.length) {
			submenu.height(submenu.prop("scrollHeight"));
		} else {
			submenu.height(0);
		}
	}

	$('.main-navbar .menu-item-has-children > a').on('click tap', submenuToggle);

	function closeMenuOnClick(event) {
		if (!$(event.target).parent().hasClass('menu-item-has-children')) {
			menuToggle();
		}
	}
	$('.main-navbar a').on('click', function (e) {
		if (window.matchMedia('(max-width: 1200px)').matches) {
			closeMenuOnClick(e)
			return
		}
	})
	$('footer a[href="#"]').on('click', function (e) {
		e.preventDefault();
	});

	// Toggle header size
	function toggleHeaderSize() {
		const header = $('header.header')

		$(window).scrollTop() > 0
			? header.addClass('small')
			: header.removeClass('small')
	}

	// Toggle active section
	function toggleActiveSection() {
		// const mainSections = document.querySelectorAll('main > [id]')
		const mainSections = document.querySelectorAll('main > *')
		
		const observer = new IntersectionObserver(entries => {
			entries.forEach(entry => {
				if (entry.isIntersecting) {
					const sectionId = entry.target.id
					const anchorLinks = document.querySelectorAll('nav.navbar li > a[href*="#"]')

					anchorLinks.forEach(link => {
						link.classList.remove('current-section')
						
						const url = new URL(link.href)

						if (url.hash === `#${sectionId}`) {
							link.classList.add('current-section')
						}
					})
				}
			})
		}, { rootMargin: "-25% 0px -60% 0px" });

		mainSections.forEach(section => {
			observer.observe(section)
		})
	}

	$(function () {
		toggleHeaderSize()
		toggleActiveSection()
	})

	$(window).on('scroll', function () {
		toggleHeaderSize()
	})

	// Smooth scroll and dynamic target
	const anchorLinks = document.querySelectorAll('.navbar li > a[href*="#"], .footer-navbar li > a[href*="#"]')

	anchorLinks.forEach(link => {
		link.addEventListener('click', function (event) {
			const targetLink = new URL(this.href)
			const currentLink = new URL(window.location.href)
			
			const targetPath = targetLink.pathname.split('/').filter(path => path)
			const currentPath = currentLink.pathname.split('/').filter(path => path)
			
			const isSamePath = 
			    targetPath.length === currentPath.length &&
			    targetPath.every((element, index) => element === currentPath[index])
            
			if(!isSamePath) return
			
			event.preventDefault()
			
			const hash = targetLink.hash
			const targetElement = document.querySelector(hash)
			const isMobile = window.innerWidth < 1200;
			const hasChildItem = this.parentElement.classList.contains('menu-item-has-children');
			
			if(!targetElement) return
            
			if (isMobile && hasChildItem) return
			
			window.scrollTo({
				top: targetElement.offsetTop - (window.innerHeight * 0.05),
				behavior: 'smooth'
			})
		})
	})

})(jQuery);
(function($) {
    /* SLIDER DE PRATOS */
    updateSlider('home'); // Página home
    updateSlider('menu'); // Página do menu específico
    
    /* ADICIONA EXIBIÇÃO DE MAIS POSTS */
    
    var exclude = []; // Variável que recebe todos os posts que já apareceram
    
    jQuery('.load-more:not([disabled])').on('click', function () {
      
      exclude = [];
      
      jQuery('.menus .section-content .card-menu').each(function () {
        exclude.push(jQuery(this).attr('id'));  // Adiciona os posts que já apareceram em "veja mais"
      });
       
      jQuery('.load-more').attr('disabled', true);
      
      jQuery.ajax({
        method: "POST",
        url: ajaxUrl, //Variavel definida no header
        data: {
            action: 'festival_get_more_menus',
            exclude: exclude,
            tipo: params['tipo']
        },
        success: function(response) {
          if (response) {
            let menus = response.substr(1,(response.length - 2));
            jQuery('.menus .imagens').slick('unslick');
            jQuery('.menus .section-content').append(menus);
            updateSlider('home');
            jQuery('.menus .imagens').addClass('visible');
          } else {
            jQuery('.load-more-container').html('<p>Todas as opções foram exibidas</p>')
          }
        },
        
        error: function(errorThrown){
          console.log(errorThrown);
        },
        
        complete: function() {
           jQuery('.load-more').attr('disabled', false);
        }
        
      })
    });
    
})(jQuery);

function updateSlider(page) {
  
    switch (page) {
      
      case 'home': 
        jQuery('.menus .card-menu .imagens').slick({
            arrows: false,
            dots: false,
            slidesToShow: 1,
            slidesToScroll: 1,  
            autoplay: true,
            autoplaySpeed: 3000,
            pauseOnHover: false
        });
        break;
        
      case 'menu':
        jQuery('.fotos-pratos .imagens').slick({
            arrows: false,
            dots: false,
            slidesToShow: 3,
            slidesToScroll: 1,  
            autoplay: true,
            autoplaySpeed: 3000,
            pauseOnHover: false,
            responsive: [
              {
                breakpoint: 520,
                settings: {
                  slidesToShow: 2
                }
              },
              {
                breakpoint: 370,
                settings: {
                  slidesToShow: 1
                }
              }
            ]
        });
        break;
    }
  }

  function getSearchParameters() {
      var prmstr = window.location.search.substr(1);
      return prmstr != null && prmstr != "" ? transformToAssocArray(prmstr) : {};
  }
  
  function transformToAssocArray( prmstr ) {
      var params = {};
      var prmarr = prmstr.split("&");
      for ( var i = 0; i < prmarr.length; i++) {
          var tmparr = prmarr[i].split("=");
          params[tmparr[0]] = tmparr[1];
      }
      return params;
  }
  
  var params = getSearchParameters();
  
  
  
  
  
  
  
  
  
  function windowSize() {
   return jQuery(window).width();
  }
(function($) {
    
    class PesquisaPopup {
        constructor(element) {
            this.element = element
            this.rejectButton = element.querySelector('.reject-button')
            
            this._init()
        }
        
        _init() {
            this.rejectButton.addEventListener('click', () => {
                this._closePopup()
            })
            
            if(document.querySelector('.lgpd-container')) {
                window.addEventListener('DestroyLGPD', () => {
                    setTimeout(() => {
                        this._showPopup()
                    }, 2000)
                })
            } else {
                setTimeout(() => {
                    this._showPopup()
                }, 2000)
            }
        }
        
        _showPopup() {
            this.element.classList.remove('hidden')
        }
        
        _closePopup() {
            document.cookie = `pesquisa_rejeitada=true;max-age=${60 * 60 * 24 * 7}` // 7 dias
            this.element.remove()
        }
    }
    
    const popup = document.querySelector('.pesquisa-popup')
    
    if(popup) {
        new PesquisaPopup(popup)
    }
    
})(jQuery);
(function ($) {
    // Current Day
    function highlightCurrentDay() {
        const days = ['Domingo', 'Segunda-feira', 'Terça-feira', 'Quarta-feira', 'Quinta-feira', 'Sexta-feira', 'Sábado']
        const today = new Date().getDay()
        const todaySchedule = document.querySelector(`.page-menu .horarios tr[data-day="${days[today]}"]`);
        
        if(todaySchedule) todaySchedule.classList.add('current')
    }
    
    $(function() { highlightCurrentDay() })
    
    // Menu slider
    const menu = $('.page-menu .slider')
    
    if(menu.length) {
        menu.slick({
            infinite: false,
            arrows: false,
            dots: false,
            slidesToShow: 1,
            slidesToScroll: 1,  
            autoplay: true,
            autoplaySpeed: 6000,
            pauseOnHover: false,
            pauseOnFocus: false,
            fade: true,
            speed: 1000
        })
    }

})(jQuery);